import { gql } from "@apollo/client";

/**
 * Write invitations the platform's bulk-invite flow just sent to the outreach
 * log, so an invite leaves the same trail every other outreach tool leaves and
 * shows up on the results board. `source` says which screen sent it; without it
 * an invite from a member's page and one from a cohort are the same row.
 */
export const RECORD_INVITES = gql`
  mutation adminRecordInvites(
    $eventId: String!
    $userIds: [String!]!
    $source: OutreachSource
    $filters: [String!]
  ) {
    adminRecordInvites(eventId: $eventId, userIds: $userIds, source: $source, filters: $filters)
  }
`;
